export default __webpack_public_path__ + "static/media/DarkBlue0002.4b7f2046.png";